<div>
  <span
    [ngClass]="[
      'w-4',
      'h-4',
      'rounded-full',
      'inline-block',
      'mr-2',
      colorClass,
    ]"></span>
  {{ status }}
</div>
